import StateType from './state.type';

export default {
  loading: false,
  categories: [],
  total: 0,
} as StateType;
